import { DOCUMENT } from '@angular/common';
import {
  Component,
  Injector,
  OnInit,
  createNgModuleRef,
  ViewChild,
  ViewContainerRef,
  Inject,
  OnDestroy
} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { GlobalConstants } from 'src/app/common/global-constants';
import { Router, NavigationEnd } from '@angular/router';
import { SchemaService } from 'src/app/services/schema-service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent implements OnInit, OnDestroy {
  @ViewChild('components', { read: ViewContainerRef }) components: ViewContainerRef;
  public pageobj: any = { data: [] };
  public pagefound: boolean = true;
  sections: Array<any>;
  showDownloadModal: boolean = false;
  private routerSubscription: Subscription;

  constructor(
    private injector: Injector,
    private metaTagService: Meta,
    private titleService: Title,
    private router: Router,
    private schemaService: SchemaService,
    @Inject(DOCUMENT) private document: Document) {
  }

  ngOnInit(): void {
    if (typeof window === undefined || this.document.getElementById('main-slider') === null) {
      this.pageobj = GlobalConstants.activePage;
      if (!this.pageobj.status) {
        this.pagefound = false;
      } else {
        this.updatePageMeta();
        this.addSchemaOrgScript();
      }
      this.loadModules();
    }

    this.routerSubscription = this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.schemaService.resetSchemas();
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private addSchemaOrgScript() {
    if (this.router.url === '/hakkimizda/hizmet-noktalarimiz/subelerimiz') {
      this.schemaService.addOrganizationSchema();
      this.schemaService.addBreadcrumbSchema();
      return; 
    }
    
    if (this.router.url === '/hakkimizda/bizi-taniyin/aktifbank-hakkinda') {
      this.schemaService.addAboutPageSchema();
      this.schemaService.addBreadcrumbSchema();
      return;
    }
    
    else if (this.router.url === '/n-kolay/krediler') {
      this.schemaService.addLoanCollectionSchema();
    }
    else if (this.router.url.includes('/n-kolay/krediler/')) {
      this.schemaService.addLoanSchemas();
    }
    else if (this.router.url.includes('/n-kolay/yatirim/')) {
      this.schemaService.addInvestmentSchemas();
    }
    else if (this.router.url.includes('/n-kolay/kartlar/')) {
      this.schemaService.addCardSchemas();
    }
    if (this.router.url !== '/' && this.router.url !== '/hakkimizda/hizmet-noktalarimiz/subelerimiz') {
      this.schemaService.addBreadcrumbSchema();
    }
  }

  async loadModules() {
    if (!this.pagefound) {
      const module = await import('../../pages/not-found/not-found.module');
      const moduleRef = createNgModuleRef((await module).NotFoundModule, this.injector)
      const component = moduleRef.instance.getComponent();
      const componentRef = this.components.createComponent(component, { index: 0 });
      this.sections.push(componentRef.location);
      return;
    }
    this.sections = new Array<any>();
    let index = 0;
    for (const element of this.pageobj.data) {
      switch (element.componentname) {
        case 'main_slider':
          {
            const module = await import('../../organisms/main-slider/main-slider.module');
            const moduleRef = createNgModuleRef((await module).MainSliderModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'search_result':
          {
            const module = await import('../../organisms/search-result/search-result.module');
            const moduleRef = createNgModuleRef((await module).SearchResultModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'spot_markets':
          {
            const module = await import('../../organisms/exchange-rates/exchange-rates.module');
            const moduleRef = createNgModuleRef((await module).ExchangeRatesModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.forexdata = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'help_cards':
          {
            const module = await import('../../organisms/help-cards/help-cards.module');
            const moduleRef = createNgModuleRef((await module).HelpCardsModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'banner_mobileapp':
          {
            const module = await import('../../organisms/banner-mobileapp/banner-mobileapp.module');
            const moduleRef = createNgModuleRef((await module).BannerMobileAppModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'calculator_kredi':
        case 'calculator_yatirim':
          {
            const module = await import('../../organisms/spot-loan/spot-loan.module');
            const moduleRef = createNgModuleRef((await module).SpotLoanModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'spot_pagelist':
          {
            const module = await import('../../organisms/carousel-pagelist/carousel-pagelist.module');
            const moduleRef = createNgModuleRef((await module).CarouselPageListModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'news_list':
          {
            const module = await import('../../organisms/spot-news/spot-news.module');
            const moduleRef = createNgModuleRef((await module).SpotNewsModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'spot_companies':
          {
            const module = await import('../../organisms/carousel-logolist/carousel-logolist.module');
            const moduleRef = createNgModuleRef((await module).CarouselLogoListModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'contact_box':
          {
            const module = await import('../../organisms/contact_box/contact_box.module');
            const moduleRef = createNgModuleRef((await module).ContactBoxModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'breadcrumb':
          {
            const module = await import('../../organisms/breadcrumb/breadcrumb.module');
            const moduleRef = createNgModuleRef((await module).BreadcrumbModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'banner':
          {
            const module = await import('../../organisms/banner/banner.module');
            const moduleRef = createNgModuleRef((await module).BannerModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'credit_list':
          {
            const module = await import('../../organisms/credit-list/credit-list.module');
            const moduleRef = createNgModuleRef((await module).CreditListModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'subpage_manuellist':
          {
            const module = await import('../../organisms/subpage-manuellist/subpage-manuellist.module');
            const moduleRef = createNgModuleRef((await module).SubPageManuelListModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'banner_calculator':
          {
            const module = await import('../../organisms/banner-calculator/banner-calculator.module');
            const moduleRef = createNgModuleRef((await module).BannerCalculatorModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'page_navigation':
          {
            const module = await import('../../organisms/page-navigation/page-navigation.module');
            const moduleRef = createNgModuleRef((await module).PageNavigationModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'product_detail':
          {
            const module = await import('../../organisms/product-detail/product-detail.module');
            const moduleRef = createNgModuleRef((await module).ProductDetailModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'collapse':
          {
            const module = await import('../../organisms/collapse/collapse.module');
            const moduleRef = createNgModuleRef((await module).CollapseModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'rate_and_price':
          {
            const module = await import('../../organisms/rate-and-price/rate-and-price.module');
            const moduleRef = createNgModuleRef((await module).RateAndPriceModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

          case 'branch_list':
            {
              const module = await import('../../organisms/branch-list/branch-list.module');
              const moduleRef = createNgModuleRef((await module).BranchListModule, this.injector)
              const component = moduleRef.instance.getComponent();
  
              const componentRef = this.components.createComponent(component, { index: index });
              componentRef.instance.data = element;
              componentRef.location.nativeElement.id = element.slug;
              this.sections.push(componentRef.location);
              index++;
            }
            break;

            case 'main_header':
              {
                const module = await import('../../organisms/main-header/main-header.module');
                const moduleRef = createNgModuleRef((await module).MainHeaderModule, this.injector)
                const component = moduleRef.instance.getComponent();
    
                const componentRef = this.components.createComponent(component, { index: index });
                componentRef.instance.data = element;
                componentRef.location.nativeElement.id = element.slug;
                this.sections.push(componentRef.location);
                index++;
              }
              break;

            case 'taksitli_alisveris_liste':
              {
                const module = await import('../../organisms/taksitli-alisveris-liste/taksitli-alisveris-liste.module');
                const moduleRef = createNgModuleRef((await module).TaksitliAlisverisListeModule, this.injector)
                const component = moduleRef.instance.getComponent();
    
                const componentRef = this.components.createComponent(component, { index: index });
                componentRef.instance.data = element;
                componentRef.location.nativeElement.id = element.slug;
                this.sections.push(componentRef.location);
                index++;
              }
              break;

        case 'page_note':
          {
            const module = await import('../../organisms/page-note/page-note.module');
            const moduleRef = createNgModuleRef((await module).PageNoteModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'full_text_grid':
          {
            const module = await import('../../organisms/full-text-grid/full-text-grid.module');
            const moduleRef = createNgModuleRef((await module).FullTextGridModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'mil_stones':
          {
            const module = await import('../../organisms/mil-stones/mil-stones.module');
            const moduleRef = createNgModuleRef((await module).MilStonesModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'sector_list':
          {
            const module = await import('../../organisms/sector-list/sector-list.module');
            const moduleRef = createNgModuleRef((await module).SectorListModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'person_message':
          {
            const module = await import('../../organisms/person-message/person-message.module');
            const moduleRef = createNgModuleRef((await module).PersonMessageModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'management_staff':
          {
            const module = await import('../../organisms/management-staff/management-staff.module');
            const moduleRef = createNgModuleRef((await module).ManagementStaffModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'management_staff_slide':
          {
            const module = await import('../../organisms/management-staff-slide/management-staff-slide.module');
            const moduleRef = createNgModuleRef((await module).ManagementStaffSlideModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'link_list':
          {
            const module = await import('../../organisms/link-list/link-list.module');
            const moduleRef = createNgModuleRef((await module).LinkListModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'doc_list':
          {
            const module = await import('../../organisms/doc-list/doc-list.module');
            const moduleRef = createNgModuleRef((await module).DocListModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'filterdoc_list':
          {
            const module = await import('../../organisms/filterdoc-list/filterdoc-list.module');
            const moduleRef = createNgModuleRef((await module).FilterDocListModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'award_list':
          {
            const module = await import('../../organisms/award-list/award-list.module');
            const moduleRef = createNgModuleRef((await module).AwardListModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'subpage_list':
          {
            const module = await import('../../organisms/subpage-list/subpage-list.module');
            const moduleRef = createNgModuleRef((await module).SubpageListModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'video_list':
          {
            const module = await import('../../organisms/video-list/video-list.module');
            const moduleRef = createNgModuleRef((await module).VideoListModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'branchcard_list':
          {
            const module = await import('../../organisms/branchcard-list/branchcard-list.module');
            const moduleRef = createNgModuleRef((await module).BranchCardListModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'contactbox_list':
          {
            const module = await import('../../organisms/contactbox-list/contactbox-list.module');
            const moduleRef = createNgModuleRef((await module).ContactBoxListModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'contact_form':
          {
            const module = await import('../../organisms/contact-form/contact-form.module');
            const moduleRef = createNgModuleRef((await module).ContactFormModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'contact_information':
          {
            const module = await import('../../organisms/contact-information/contact-information.module');
            const moduleRef = createNgModuleRef((await module).ContactInformationModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'employee_profile':
          {
            const module = await import('../../organisms/employee-profile/employee-profile.module');
            const moduleRef = createNgModuleRef((await module).EmployeeProfileModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'zaman_asimi_formu':
          {
            const module = await import('../../organisms/zaman-asimi-formu/zaman-asimi-formu.module');
            const moduleRef = createNgModuleRef((await module).ZamanAsimiFormuModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

        case 'sitemap':
          {
            const module = await import('../../organisms/sitemap/sitemap.module');
            const moduleRef = createNgModuleRef((await module).SitemapModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;
        
          case 'bank_information':
          {
            const module = await import('../../organisms/banka-bilgilendirme/banka-bilgilendirme.module');
            const moduleRef = createNgModuleRef((await module).BankaBilgilendirmeModule, this.injector)
            const component = moduleRef.instance.getComponent();

            const componentRef = this.components.createComponent(component, { index: index });
            componentRef.instance.data = element;
            componentRef.location.nativeElement.id = element.slug;
            this.sections.push(componentRef.location);
            index++;
          }
          break;

      }
    }

    if (GlobalConstants.popup != null && GlobalConstants.popup != undefined) {
      const module = await import('../../organisms/general-modal/general-modal.module');
      const moduleRef = createNgModuleRef((await module).GeneralModalModule, this.injector)
      const component = moduleRef.instance.getComponent();

      const componentRef = this.components.createComponent(component, { index: index });
      componentRef.instance.data = GlobalConstants.popup;
      componentRef.location.nativeElement.id = "general-modal";
      this.sections.push(componentRef.location);
      index++;
    }
  }

  updatePageMeta() {
    if (this.pageobj && this.pageobj.page_info && this.pagefound) {
      if (this.pageobj.page_info.metaTitle) {
        this.titleService.setTitle(this.pageobj.page_info.metaTitle);
      } else if (this.pageobj.page_info.title) {
        this.titleService.setTitle(
          this.pageobj.page_info.title + ' | Aktif Bank',
        );
      } else {
        this.titleService.setTitle('Aktif Bank');
      }
      
      try {
        const metaTags = Array.from(this.document.getElementsByTagName('meta'));
        metaTags.forEach(tag => {
          if (tag.getAttribute('name') === 'description' && tag.parentElement) {
            tag.parentElement.removeChild(tag);
          }
        });
      } catch (e) {
        console.error('Meta tag removal error:', e);
      }
      
      if (this.pageobj.page_info.description) {
        this.metaTagService.addTag({
          name: 'description',
          content: this.pageobj.page_info.description,
        });
      } else {
        this.metaTagService.addTag({
          name: 'description',
          content:
            'Türkiye\'nin en büyük özel sermayeli yatırım bankası.',
        });
      }

      const linkElems = this.document.getElementsByTagName('link');
      let link: any = undefined;
      for (let index = 0; index < linkElems.length; index++) {
        const element = linkElems[index];
        if (element.getAttribute('rel') == 'canonical') {
          link = element;
        }
      }

      let domainurl = GlobalConstants.apiURL;
      let siteurl = this.pageobj.page_info.url;
      domainurl = domainurl.replace("/api", "/");
      domainurl = domainurl.replace("http://", "https://");
      while (domainurl.endsWith('/')) {
        domainurl = domainurl.slice(0, -1);
      }

      while (siteurl.charAt(0) === "/") {
        siteurl = siteurl.substring(1);
      }
      const canonicalLinkElement = Array.from(this.document.getElementsByTagName('link')).find(el => el.getAttribute('rel') === 'canonical');
      if (canonicalLinkElement) {
        canonicalLinkElement.setAttribute('href', domainurl + '/' + siteurl);
      } else {
        link = this.document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', domainurl + '/' + siteurl);
        this.document.head.appendChild(link);
      }
    }
  }

}
